namespace TabAurous.OMS {
    export interface RateMasterForm {
        CostId: Serenity.StringEditor;
        ProductTypeId: Serenity.LookupEditor;
        CategoryId: CommonCategoryLookup;
        SubCategoryId: CommonSubCategoryLookup;
        ShapeId: Serenity.LookupEditor;
        StoneColorId: Serenity.LookupEditor;
        QualityId: Serenity.LookupEditor;
        StoneSizeId: Serenity.LookupEditor;
        SieveId: Serenity.LookupEditor;
        FromWt: WeightEditor;
        ToWt: WeightEditor;
        FromDate: Serenity.DateEditor;
        ToDate: Serenity.DateEditor;
        PurStdRate: AmountEditor;
        SaleStdRate: AmountEditor;
        ProductId: Serenity.StringEditor;
        AttributeId: Serenity.IntegerEditor;
        ItemTypeId: Serenity.LookupEditor;
    }

    export class RateMasterForm extends Serenity.PrefixedContext {
        static formKey = 'OMS.RateMaster';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!RateMasterForm.init)  {
                RateMasterForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.LookupEditor;
                var w2 = CommonCategoryLookup;
                var w3 = CommonSubCategoryLookup;
                var w4 = WeightEditor;
                var w5 = s.DateEditor;
                var w6 = AmountEditor;
                var w7 = s.IntegerEditor;

                Q.initFormType(RateMasterForm, [
                    'CostId', w0,
                    'ProductTypeId', w1,
                    'CategoryId', w2,
                    'SubCategoryId', w3,
                    'ShapeId', w1,
                    'StoneColorId', w1,
                    'QualityId', w1,
                    'StoneSizeId', w1,
                    'SieveId', w1,
                    'FromWt', w4,
                    'ToWt', w4,
                    'FromDate', w5,
                    'ToDate', w5,
                    'PurStdRate', w6,
                    'SaleStdRate', w6,
                    'ProductId', w0,
                    'AttributeId', w7,
                    'ItemTypeId', w1
                ]);
            }
        }
    }
}
